<template>



  <div class="panels">


    <Card header="Versandbereit"  :class="{'toggled': panel.toggled}" v-for="panel in panels" v-bind:key="panel.id">
      <template #title>
        <Button v-if="!panel.toggled" icon="pi pi-minus" @click="togglePanel(panel)" variant="text" severity="contrast" size="small" />
        <Button v-if="panel.toggled" icon="pi pi-plus" @click="togglePanel(panel)" variant="text" severity="contrast" size="small" />
        <span v-if="!panel.toggled">{{panel.label}} </span> <Badge :severity="badgeSeverity(panel)" :value="countOrders(panel.orders)" />
      </template>

      <template #content v-if="!panel.toggled">
      <DataTable  size="small" :globalFilterFields="['order.orderNumber', 'order.orderCustomer.firstName', 'order.orderCustomer.lastName']"  v-model:filters="panel.panelFilters"  v-if="countOrders(panel.orders)" v-model:selection="panel.selectedOrders" @row-dblclick="showOrderDetails" :value="panel.orders" selectionMode="multiple" dataKey="order.id" :loading="ordersLoading">
        <template #header>
          <div class="flex justify-end">


              <InputText v-model="panel.panelFilters['global'].value" placeholder="Keyword Search" />

          </div>
        </template>
        <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
        <Column field="order.orderNumber" header="Nr.">
          <template #body="slotProps">
            {{ slotProps.data.order.orderNumber }}<br />
            <small>{{ formatDate(slotProps.data.order.orderDateTime)  }}</small>
          </template>
        </Column>
        <Column header="Name">
          <template #body="slotProps">
            {{ slotProps.data.order.orderCustomer.firstName }} {{ slotProps.data.order.orderCustomer.lastName }}

            <i class="pi-comment pi" style="color: red;" v-if="slotProps.data.order.customerComment" :title="slotProps.data.order.customerComment"></i>
          </template>
        </Column>
        <Column header="Versand">
          <template #body="slotProps">
            {{ slotProps.data.order.deliveries[0]?.shippingMethod?.name }}
          </template>
        </Column>
        <Column field="order.amountTotal" header="Summe">
          <template #body="slotProps">
            {{formatCurrency(slotProps.data.order.amountTotal)}}
          </template>

        </Column>
        <Column header="Dokumente">
          <template #body="slotProps">
            <Badge value="4" severity="success" v-if="documentExists(slotProps.data.documents, 'shipping')">V</Badge>
            <Badge value="4" severity="danger" v-if="!documentExists(slotProps.data.documents, 'shipping')">V</Badge>
            <Badge value="4" severity="success" v-if="documentExists(slotProps.data.documents, 'invoice')">R</Badge>
            <Badge value="4" severity="danger" v-if="!documentExists(slotProps.data.documents, 'invoice')">R</Badge>
            <Badge value="4" severity="success" v-if="documentExists(slotProps.data.documents, 'delivery')">L</Badge>
            <Badge value="4" severity="danger" v-if="!documentExists(slotProps.data.documents, 'delivery')">L</Badge>
          </template>
        </Column>
      </DataTable>

      <div style="display: flex;justify-content: center;margin-top: 1em;" v-if="countOrders(panel.orders)">

        <Button type="button"  :severity="action.severity"  v-for="action in panel.actions" :icon="action.icon"  v-bind:key="action" class="w-full" :disabled="ordersLoading" @click="action.action(panel)" :label="action.label"></Button>
      </div>

        <div v-if="!countOrders(panel.orders)" style="text-align: center;">
          <p>Keine Bestellungen</p>
        </div>


      </template>
    </Card>

  </div>



  <Drawer  v-model:visible="orderDetails" header="Drawer"  style="width: 60rem;">

    <template #header>

      <h2>Bestellung {{orderDetails.orderNumber}} vom {{ formatDate(orderDetails.orderDateTime)}}</h2>
    </template>
    <template #footer>

      <div style="display: flex;justify-content: space-between;">


<Button target="_blank" :href="orderLink(orderDetails.id)" as="a" >Bestellung öffnen</Button>


          <Form  @submit="onShippingMethodChange(orderDetails)" class="flex-auto" >
            <Select v-model="shippingMethod" :options="shippingMethods" optionLabel="name" placeholder="Versandart wählen" class="w-full md:w-56" />
            <Button type="submit" severity="secondary" label="Versandart ändern" />
            </Form>





      </div>
    </template>

    <div v-if="orderDetails">

    <dl style="font-size: 1.2em;">
      <dt>
        Summe Brutto:  {{ formatCurrency(orderDetails.amountTotal)}}
      </dt>
      <dt>
        Summe Netto:   {{ formatCurrency(orderDetails.amountNet)}}
      </dt>
      <dt>
        Versandkosten:  {{ formatCurrency(orderDetails.shippingTotal)}}
      </dt>
    </dl>

      <dl style="font-size: 1.2em;">
        <dt>
          Versandart:  {{ orderDetails.deliveries[0].shippingMethod?.name || 'Keine Versandart hinterlegt'}}
        </dt>
        <dt>
          Zahlart:   {{ orderDetails.transactions[0]?.paymentMethod?.name || 'Keine Zahlart hinterlegt'}}
        </dt>

      </dl>

      <p style="color: red;" ng-if="orderDetails.customerComment">
        {{orderDetails.customerComment}}
      </p>
    <DataTable  :value="orderDetails.lineItems" selectionMode="multiple" dataKey="order.id" :loading="ordersLoading">
      <Column field="payload.productNumber" header="Produktnummer"></Column>
      <Column field="label" header="Name"></Column>
      <Column field="quantity" header="Anzahl"></Column>
      <Column field="product.weight" header="Gewicht">
        <template #body="slotProps">
          <span v-if="slotProps.data.product">
          {{ formatWeight( slotProps.data.product.weight??null) }}
            </span>
        </template>
      </Column>
        <Column field="totalPrice" header="Preis">
        <template #body="slotProps">
          {{formatCurrency(slotProps.data.totalPrice)}}
        </template>
      </Column>
    </DataTable>



    </div>

  </Drawer>


</template>

<script>


import DataTable from "primevue/datatable";
import Column from 'primevue/column';
import Button from "primevue/button";
import axios from "@/api/axios";

const API_ENDPOINT = process.env.VUE_APP_API_BASE_URL;
import Badge from "primevue/badge";
import { useToast } from 'primevue/usetoast';
import moment from "moment/moment";
import Drawer from "primevue/drawer";
import { FilterMatchMode } from '@primevue/core/api';
import InputText from "primevue/inputtext";
import {Select} from "primevue";
import {Form} from "@primevue/forms";
import Card from "primevue/card";


export default {
  name: 'HelloWorld',
  components: {DataTable, Column, Button, Badge, Drawer, InputText, Select, Form, Card},
  props: {
    msg: String
  },
  data(){
    return {

      shippingMethod: null,
      isToggled: false,
      orderDetails: null,
      selectedOrders:[],
      ordersLoading: false,
      orders: [],
      shippingMethods: [],
      loadingInterval: null,
      panels:[
        {
          id: 1,
          toggled: false,
          label: 'Offen',
          description: 'Bestellungen die bereits bezahlt wurden sowie auf Rechnung.',
          panelFilters: {
            global: {value: null, matchMode: FilterMatchMode.CONTAINS}
          },
          filter:{
            operator: 'OR',
            criteria: [{
              'stateMachineState.technicalName': ['open'],
              'transactions.stateMachineState.technicalName': ['open'],
              '!transactions.paymentMethod.name': ['Rechnung', 'Rechnung für Stammkunden'],
            }]
          },
          actionsLabel: 'Dokumente erstellen',
          actions: [
            {label: 'Als bezahlt markieren', icon: 'pi pi-credit-card',severity: 'success',   action: (el)=>this.transition(el, 'order_transaction', 'paid')}
          ],
          selectedOrders:[],
        },
        {
          id: 3,
          toggled: false,
          orders: [],
          label: 'Bezahlt/Rechnung + Vorbestellt',
          description: 'Vorbestellungen die später versendet werden. Rechnung ist bereits bezahlt und vorhanden.',
          panelFilters: {
            global: {value: null, matchMode: FilterMatchMode.CONTAINS}
          },
          filter:{
            documents: ['shipping', 'invoice', 'delivery'],
            documentsExists: false,
            operator: 'AND',
            criteria:[{
              'tags.name': ['Vorbestellung'],
              'stateMachineState.technicalName': ['open'],
              'transactions.stateMachineState.technicalName': ['paid'],
              'deliveries.stateMachineState.technicalName': []
            },
              {
                'tags.name': ['Vorbestellung'],
                'stateMachineState.technicalName': ['open'],
                'transactions.stateMachineState.technicalName': ['open'],
                'transactions.paymentMethod.name': ['Rechnung', 'Rechnung für Stammkunden'],
                'deliveries.stateMachineState.technicalName': []
              }
            ]
          },
          actionsLabel: 'Dokumente erstellen',
          actions: [
            {label: 'Versand vorbereiten', severity: 'success', icon: 'pi pi-sign-in', action: (el)=>this.transition(el, 'order', 'process')},
            {label: 'Rechnung erstellen', severity: 'secondary', icon: 'pi pi-receipt', action: (el)=>this.createDocuments(el, 'invoice')},
            {label: 'Rechnung herunterladen', severity: 'secondary', icon: 'pi pi-download', action: (el)=>this.mergeDocuments(el, 'invoice')},
          ],
          selectedOrders:[],
        },
        {
          id: 2,
          toggled: false,
          label: 'Bezahlt/Rechnung',
          description: 'Bestellungen die bereits bezahlt wurden sowie auf Rechnung.',
          panelFilters: {
            global: {value: null, matchMode: FilterMatchMode.CONTAINS}
          },
          filter:{
            operator: 'OR',
            criteria:[{
              '!tags.name': ['Vorbestellung'],
              'stateMachineState.technicalName': ['open'],
              'transactions.stateMachineState.technicalName': ['paid'],
              'deliveries.stateMachineState.technicalName': []
            },
              {
                '!tags.name': ['Vorbestellung'],
                'stateMachineState.technicalName': ['open'],
                'transactions.stateMachineState.technicalName': ['open'],
                'transactions.paymentMethod.name': ['Rechnung', 'Rechnung für Stammkunden'],
                'deliveries.stateMachineState.technicalName': []
              }
              ]
          },
          actionsLabel: 'Dokumente erstellen',
          actions: [
            {label: 'Versand vorbereiten', severity: 'success', icon: 'pi pi-sign-in', action: (el)=>this.transition(el, 'order', 'process')},
            {label: 'Vorbestellung', severity: 'success', icon: 'pi pi-hourglass', action: (el)=>this.toggleTag(el, ' 019970a1e2bf782a98b0a1bdf609f961')},

          ],
          selectedOrders:[],
        },

        {
          id: 4,
          toggled: false,
          orders: [],
          label: 'In Bearbeitung',
          description: 'Bestellungen die ',
          panelFilters: {
            global: {value: null, matchMode: FilterMatchMode.CONTAINS}
          },
          filter:{
            documents: ['shipping', 'invoice', 'delivery'],
            documentsExists: false,
            operator: 'AND',
            criteria:[{
              'stateMachineState.technicalName': ['in_progress'],
              'deliveries.stateMachineState.technicalName': ['open']
            }]
          },
          actionsLabel: null,
          actions: [
            {label: 'Dokumente erstellen', severity: 'success', icon: 'pi pi-receipt', action: (el)=>this.createDocuments(el)}
          ],
          selectedOrders:[],
        },
        {
          id: 5,
          toggled: false,
          orders: [],
          label: 'Versandbereit',
          panelFilters: {
            global: {value: null, matchMode: FilterMatchMode.CONTAINS}
          },
          filter:{
            documents: ['shipping', 'invoice', 'delivery'],
            documentsExists: true,
            operator: 'AND',
            criteria:[{
              'stateMachineState.technicalName': ['in_progress'],
              'deliveries.stateMachineState.technicalName': ['open']
            },
            ]
          },
          actionsLabel: 'Dokumente herunterladen',
          actions: [
            {label: 'Rechnungen', severity: 'secondary', icon: 'pi pi-download',action: (el)=>this.mergeDocuments(el, 'invoice')},
            {label: 'Lieferscheine', severity: 'secondary', icon: 'pi pi-download',action: (el)=>this.mergeDocuments(el, 'deliveryNote')},
            {label: 'Versandetiketten', severity: 'secondary', icon: 'pi pi-download',action: (el)=>this.mergeDocuments(el, 'shipping')},
            {label: 'Abschließen', severity: 'success', icon: 'pi pi-check', action: (el)=>this.transition(el, 'order', 'complete')},
          ],
          selectedOrders:[],
        },
      ]
    }
  },
  created(){

    axios.get(API_ENDPOINT + '/api/shippingMethods').then((response)=>{
      this.shippingMethods = response.data.shippingMethods;

      console.log(this.shippingMethods);
    });


    this.loadOrders();

    this.toastService =  useToast();

  },
  methods:{
    badgeSeverity(panel){
      return (this.countOrders(panel.orders) > 0) ? 'success' : 'secondary';
    },
    togglePanel(panel){
      panel.toggled = !panel.toggled;
    },

    formatCurrency(price){

      return String(price).replace('.', ',')+'€';
    },

    formatWeight(weight){

      if( typeof weight !== 'undefined' ){
        if( weight >= 1){
          return weight  + ' kg';
        }else{
          return (weight * 1000)  + ' g';
        }

      }else{
        return '-';
      }


    },

    onShippingMethodChange(el){


      axios.post(API_ENDPOINT + '/api/shippingMethod', {
        deliveryId: el.deliveries[0].id,
        shippingMethodId: this.shippingMethod.id
      }).then(()=>{
        this.loadOrders()
      });

    },

    formResolver(){

    },

    orderLink(orderId){

      return 'https://engel-liebhabershop.de/admin#/sw/order/detail/'+orderId+'/general';

    },

    documentExists(documents, document){

      if( !documents || !documents.length) return false;
      return documents.indexOf(document) > -1;
    },

    bla(event){
      console.log(event);
    },

    getDocuments(){

    },

    generateDocuments(){

    },

    countOrders(orders){

      if( typeof orders == 'object' && orders.length){
        return orders.length;
      }
      return 0;

    },

    togglePane(){

      this.isToggled = (!this.isToggled);
     return true;
    },

    formatDate(date){

      return moment(date).format("DD.MM.YYYY hh:mm");
    },

    showOrderDetails(event){
      this.orderDetails = event.data.order;
    },
    transition(el, type, status){

      this.toastService .add({ severity: 'success', summary: 'Info', detail: 'Bestellungen werden verarbeitet', life: 3000 });

      var ids = [];
      el.selectedOrders.forEach(order=>{
        if( type==='order_transaction' ) {
          if(order.order.transactions)
          ids.push({id: order.order.transactions[0].id, orderId: order.order.id});
        }else if(type==='order_delivery'){
          if(order.order.deliveries)
          ids.push({id: order.order.deliveries[0].id, orderId: order.order.id});
        }else{
          ids.push({id: order.order.id, orderId: order.order.id});
        }
      });

      axios.post(API_ENDPOINT + '/api/transition', {
        ids: ids,
        type: type,
        status: status
      }).then(()=>{
        this.loadOrders();
        this.ordersLoading=false;
      });



    },

    toggleTag(el, tagId){


      this.toastService.add({severity: 'success', summary: 'Info', detail: 'Tags gesetzt', life: 3000});

      var ids = [];
      el.selectedOrders.forEach(order => {
        ids.push(order.order.id);
      });

      axios.post(API_ENDPOINT + '/api/tag', {
        ids: ids,
        tagId: tagId
      }).then(() => {
        this.loadOrders();
        this.ordersLoading = false;
      });


    },

    mergeDocuments(el, type=false){


      this.toastService.add({severity: 'success', summary: 'Info', detail: 'Dokumente werden erstellt', life: 3000});

      var ids = [];
      el.selectedOrders.forEach(order => {
        ids.push(order.order.id);
      });

      axios.post(API_ENDPOINT + '/api/mergeDocuments', {
        ids: ids,
        type: type
      }).then((response) => {
        const link = document.createElement('a')
        link.href = response.data.url;
        link.download = 'merge.pdf';
        link.target='_blank';
        link.click()
        URL.revokeObjectURL(link.href)
        link.remove();

        this.loadOrders();
        this.ordersLoading = false;
      });


    },

    createDocuments(el, type=false){


        this.toastService.add({severity: 'success', summary: 'Info', detail: 'Dokumente werden erstellt', life: 3000});

        var ids = [];
        el.selectedOrders.forEach(order => {
          ids.push(order.order.id);
        });

        axios.post(API_ENDPOINT + '/api/createDocuments', {
          ids: ids,
          type: type
        }).then(() => {
          this.loadOrders();
          this.ordersLoading = false;
        });


    },

    loadOrders(){




      for(let panel of this.panels){
        this.ordersLoading=true;
        axios.post(API_ENDPOINT + '/api/orders', {
          filter: panel.filter
        }).then(response=>{
          panel.orders= response.data.orders;
          this.ordersLoading=false;
        });
      }

      clearInterval(this.loadingInterval);
      this.loadingInterval = setInterval(()=> this.loadOrders(), 10000);


    }
  }
}
</script>


<style scoped>

.p-card.p-component{
  margin: 0.3em;
  width: 100%;
}
.p-card.p-component.toggled{
  width: auto;
}

.panels{
  display: flex;
  flex-grow: 0;
  align-items: stretch;
}
.p-panel {

  margin: 0.5em;
  width: 100%;
}

.orderDetails{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;

}

.p-panel-toggleable{
  animation: 0.5s;
}


.p-panel-toggleable.toggled{
  flex-basis: 100px;

}

a{
  text-decoration: none;
  margin: 0.2em;
}

button{
  margin: 0.2em;
}

</style>
